module.exports = __webpack_public_path__ + "img/build_ico_planos.ca306cec.png";